module.exports = __webpack_public_path__ + "static/notice-dismiss-dont-e30eb1f44f2e6ee249107f91cce81576.png";